const agentModeActiveByWindow = new WeakMap<Window, boolean>();

export function setComposeAgentModeActive(targetWindow: Window, isActive: boolean): void {
    agentModeActiveByWindow.set(targetWindow, isActive);
}

export function isComposeAgentModeActive(targetWindow: Window): boolean {
    return agentModeActiveByWindow.get(targetWindow) ?? false;
}
